import LeftBox from "./LeftBox";
import RightBox from "./RightBox";
import "./box.scss"
export { LeftBox, RightBox };



// WEBPACK FOOTER //
// /src/call/container/boxes/index.js